<template>
  <div class="tile">
    <div class="lender--headshot">
      <img
        v-if="active.headshot"
        class="headshot__lg"
        :src="active.headshot"
        :alt="`${active.name.first}'s headshot`"
      />
      <span v-else class="default__avatar flex__center">{{ defaultAvatar }}</span>
    </div>
    <h3 class="content__heading mt-0">{{ active.display_name }}</h3>
    <div>
      <p class="flex__between tile--row">
        <span class="text__bold mr-10">Title:</span>
        <span>{{ active.title }}</span>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold mr-10">NMLS:</span>
        <span>{{ active.nmls }}</span>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold mr-10">Profile:</span>
        <a
          v-if="active.status.live"
          :href="`https://flatbranchhomeloans.com/team/${newURL}`"
          target="_blank"
        >here</a>
        <span v-else>N/A</span>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold mr-10">Simple Nexus:</span>
        <span>{{ active.simple_nexus }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  computed: {
    defaultAvatar() {
      const names = this.active.display_name.split(" ");
      const first = names[0].split("")[0].toUpperCase();
      const last = names[names.length - 1].split("")[0].toUpperCase();
      return `${first} ${last}`;
    },
    newURL() {
      return this.active.new_url && this.active.new_url.length > 0
        ? this.active.new_url[0].url
        : this.active.url;
    }
  }
};
</script>

<style scoped lang="scss">
</style>